<script setup>
import { ref } from 'vue'
import Breadcrumbs from '@components/global/Breadcrumbs.vue'

const props = defineProps({
	title: {
		type: String,
		required: true,
	},
	description: {
		type: String,
		required: false,
	},
	centered: {
		type: Boolean,
		required: false,
	},
	bg: {
		type: String,
		required: false,
	},
	breadcrumbs: {
		type: Array,
		required: false,
	},
})
</script>

<template>
	<section :class="['h-64', bg]">
		<div class="mt-14 h-full">
			<div class="flex h-full items-center">
				<div class="container">
					<div class="flex flex-col gap-6">
						<Breadcrumbs :breadcrumbs="breadcrumbs" v-if="breadcrumbs" />
						<div :class="['flex flex-col gap-3', { 'items-center': centered }, { 'text-snk-light-200': bg }]">
							<h1 class="h3">{{ title }}</h1>
							<p :class="[{ 'w-1/3 text-center': centered }]" v-if="description">{{ description }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
